import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { getAbtraPlayerVideosData } from '../helpers/abtraEdtitorContentParser';
import AbtraPlayerVideosRender from './AbtraPlayerVideosRender';

function AbtraEditorContentDisplay({ htmlContent, setRef, classNames }) {
    const [domRef, setDomRef] = React.useState(null);
    const contentParsed = useRef(false);
    const [abtraVideosData, setAbtraVideosData] = React.useState([]);

    const ref = useCallback((node) => {
        setDomRef(node);
        if (setRef) {
            setRef(node);
        }
    }, []);

    React.useEffect(() => {
        if (domRef && !contentParsed.current && htmlContent) {
            domRef.innerHTML = htmlContent;
            contentParsed.current = true;
            setAbtraVideosData(getAbtraPlayerVideosData(domRef));
        }

    }, [htmlContent, domRef]);
    return (
        <>
            <AbtraPlayerVideosRender
                abtraVideosData={abtraVideosData}
            />
            <div
                className={classNames || ''}
                ref={ref}
            >
            </div>
        </>
    );
}

AbtraEditorContentDisplay.propTypes = {
    htmlContent: PropTypes.string,
    setRef: PropTypes.func,
    classNames: PropTypes.string,
};

export default AbtraEditorContentDisplay;